import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Outdoor_Cameras/IN-9008_HD/Videos/video-9008-mount";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};